"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionForm = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var styles = __importStar(require("./AutomationsForm.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var MultiAccepterForm_1 = require("./SyncAccepterResponses/MultiAccepterForm");
var SyncAccepterResponses_1 = require("./SyncAccepterResponses");
var ActionFormMultiselect_1 = require("Library/AutomationLibrary/ActionFormMultiselect");
var MultiSelectCombobox_1 = __importDefault(require("Common/MultiSelectCombobox/MultiSelectCombobox"));
var AutomationUtils_1 = require("Library/AutomationLibrary/AutomationUtils");
var ActionForm = function (_a) {
    var action = _a.action, onChange = _a.onChange, integration = _a.integration;
    return (react_1.default.createElement("div", { className: styles.actionForm }, action.form &&
        action.form.map(function (field) { return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", key: field.name }, renderField({ field: field, action: action, onChange: onChange, integration: integration }))); })));
};
exports.ActionForm = ActionForm;
var renderField = function (_a) {
    var field = _a.field, action = _a.action, onChange = _a.onChange, integration = _a.integration;
    if (field.type === "dropdown") {
        return renderDropdown({ field: field, action: action, onChange: onChange, integration: integration });
    }
    else if (field.type === "multiselect") {
        return renderMultiselect({ field: field, action: action, onChange: onChange });
    }
    else if (field.type === "syncAccepterResponses") {
        return react_1.default.createElement(SyncAccepterResponses, { field: field, action: action, onChange: onChange, integration: integration });
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
var renderDropdown = function (_a) {
    var _b;
    var field = _a.field, action = _a.action, onChange = _a.onChange, integration = _a.integration;
    if (!field.hasSubField) {
        return (react_1.default.createElement(Dropdown, { label: field.label, options: field.options, value: getDropdownSelectedValue(action.config, field.name), onChange: function (option) {
                return onChange(__assign(__assign({}, action), { config: __assign(__assign({}, action.config), buildActionConfigFromDropdownValue(field.name, option.id)) }));
            }, errorMessage: getErrorMessage(field, action.config, integration.displayName) }));
    }
    var selectedOptionId = getDropdownSelectedValue(action.config, field.name);
    var errorMessage = getErrorMessage(field, action.config, integration.displayName);
    var selectedOption = field.options.find(function (option) { return option.id === selectedOptionId; });
    var subField = (selectedOptionId && selectedOption ? selectedOption : field.options[0]).subField;
    var disabledMessage = selectedOptionId && selectedOption ? undefined : "Select ".concat(field.label, " first");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown, { label: field.label, options: field.options, value: getDropdownSelectedValue(action.config, field.name), onChange: function (option) {
                return onChange(__assign(__assign({}, action), { config: __assign(__assign(__assign({}, action.config), buildActionConfigFromDropdownValue(field.name, option.id)), buildActionConfigFromDropdownValue(subField.name, undefined)) }));
            }, errorMessage: getErrorMessage(field, action.config, integration.displayName) }),
        react_1.default.createElement(Dropdown, { label: subField.label, options: subField.options, value: (_b = getDropdownSelectedValue(action.config, subField.name)) !== null && _b !== void 0 ? _b : "", onChange: function (option) {
                return onChange(__assign(__assign({}, action), { config: __assign(__assign({}, action.config), buildActionConfigFromDropdownValue(subField.name, option.id)) }));
            }, disabled: disabledMessage !== undefined, disabledMessage: disabledMessage, errorMessage: errorMessage ? undefined : getErrorMessage(subField, action.config, integration.displayName) })));
};
var renderMultiselect = function (_a) {
    var field = _a.field, action = _a.action, onChange = _a.onChange;
    var selectedOptions = (0, ActionFormMultiselect_1.getMultiselectSelectedValues)(action.config, field);
    var selectedOptionsIds = selectedOptions.map(function (o) { return ("id" in o ? o.id : (0, ActionFormMultiselect_1.getManuallyAddedItemId)(o.name)); });
    var manuallyAddedItemIcon = "informationCircle";
    var manuallyAddedTooltip = "Manually added";
    var selectedManualOptions = selectedOptions
        .filter(function (o) { return "isManuallyAdded" in o && o.isManuallyAdded; })
        .map(function (o) { return ({
        label: o.name,
        id: (0, ActionFormMultiselect_1.getManuallyAddedItemId)(o.name),
        icon: manuallyAddedItemIcon,
        isManuallyAdded: true,
    }); });
    var options = new Map(field.options.concat(selectedManualOptions).map(function (o) { return [o.id, o]; }));
    var comboboxEntries = Array.from(options.values()).map(function (o) { return ({
        label: o.label,
        labelIcon: (0, AutomationUtils_1.toIcon)(o.icon),
        tooltip: o.isManuallyAdded ? manuallyAddedTooltip : undefined,
        value: o.id,
        data: o,
    }); });
    var selectedCount = selectedOptionsIds.length;
    var inputDisabled = false;
    var inputDisabledReason;
    var selectedCountWarning;
    if (field.maxItems != null) {
        var diff = Math.max(field.maxItems - selectedCount, 0);
        if (diff <= 2) {
            if (diff === 0) {
                inputDisabled = true;
                inputDisabledReason = "Maximum number of selections reached (".concat(field.maxItems, ")");
            }
            selectedCountWarning = "".concat(diff || "No", " ").concat(diff === 1 ? "selection" : "selections", " remaining");
        }
    }
    var renderNoResultsMessage = function (searchTerm) {
        return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", align: "center", gap: "m", className: styles.noResultsMessage },
            react_1.default.createElement(kaleidoscope_1.Text, null, "No results found."),
            field.allowManuallyAddedItems && !selectedOptions.find(function (o) { return o.name === searchTerm; }) ? (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                    var manuallyAddedItem = {
                        label: searchTerm,
                        id: (0, ActionFormMultiselect_1.getManuallyAddedItemId)(searchTerm),
                        icon: manuallyAddedItemIcon,
                        isManuallyAdded: true,
                    };
                    options.set(manuallyAddedItem.id, manuallyAddedItem);
                    selectedOptionsIds.push(manuallyAddedItem.id);
                    onChange(__assign(__assign({}, action), { config: __assign(__assign({}, action.config), (0, ActionFormMultiselect_1.buildActionConfig)(action.config, field, selectedOptionsIds, options)) }));
                } },
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true },
                    "Add #",
                    searchTerm,
                    " to the list"))) : null,
            field.noMatchingItemsFooter ? (react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s", align: "center", className: styles.noMatchingItemsFooter }, field.noMatchingItemsFooter)) : null));
    };
    return (react_1.default.createElement("div", { className: styles.formComponent },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween", align: "end" },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.formLabel }, (0, lodash_1.capitalize)(field.label)),
            selectedCountWarning ? (react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs", className: styles.multiSelectCountWarning }, selectedCountWarning)) : null),
        react_1.default.createElement(MultiSelectCombobox_1.default, { entries: comboboxEntries, renderNoResultsMessage: renderNoResultsMessage, selectedValues: selectedOptionsIds, setSelectedValues: function (selectedValues) {
                onChange(__assign(__assign({}, action), { config: __assign(__assign({}, action.config), (0, ActionFormMultiselect_1.buildActionConfig)(action.config, field, selectedValues, options)) }));
            }, label: "Search ".concat(field.label), placeholder: "Enter ".concat(field.label), notFoundMessage: "Archived or deleted channel", notFoundIcon: react_1.default.createElement("div", { className: styles.notFoundIcon },
                react_1.default.createElement(icons_1.Archive, null)), inputDisabled: inputDisabled, inputDisabledReason: inputDisabledReason })));
};
var SyncAccepterResponses = function (_a) {
    var field = _a.field, action = _a.action, onChange = _a.onChange, integration = _a.integration;
    var deserialisedData = (0, SyncAccepterResponses_1.deserialiseAccepterResponses)(action.config, field);
    var _b = __read((0, react_1.useState)(deserialisedData.customFormId !== undefined), 2), showCustomForm = _b[0], _setShowCustomForm = _b[1];
    var toggleShowCustomForm = function () {
        var show = !showCustomForm;
        _setShowCustomForm(show);
        onChange(__assign(__assign({}, action), { config: (0, SyncAccepterResponses_1.serialiseAccepterResponses)(__assign(__assign({}, deserialisedData), { customFormId: !show ? undefined : deserialisedData.customFormId, customForm: !show ? undefined : deserialisedData.customForm }), { resetCustomForm: !show }) }));
    };
    var customFormError = undefined;
    var customFormDisabled = false;
    if (deserialisedData.customFormId && !deserialisedData.customForm) {
        customFormError = "Custom form not found";
    }
    else if (!deserialisedData.customFormId && field.customForms.length === 0) {
        customFormDisabled = true;
        customFormError = (react_1.default.createElement(react_1.default.Fragment, null,
            "We haven't found any custom forms in your account.",
            " ",
            react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/176-custom-forms" }, "Learn more.")));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs" }, "Choose which data inputs you want to write to HubSpot deal fields. You can add multiple accepters, but each accepters data must be mapped to different HubSpot fields."),
        react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: "showCustomForm", value: "showCustomForm", label: "Add custom form mapping" }, isSelected: showCustomForm, onChange: toggleShowCustomForm }),
        showCustomForm && (react_1.default.createElement(Dropdown, { label: "Custom form", options: field.customForms, value: deserialisedData.customFormId ? deserialisedData.customFormId : undefined, onChange: function (customForm) {
                return onChange(__assign(__assign({}, action), { config: (0, SyncAccepterResponses_1.serialiseAccepterResponses)(__assign(__assign({}, deserialisedData), { customFormId: customForm.id, customForm: customForm }), { resetCustomForm: deserialisedData.customFormId !== customForm.id }) }));
            }, disabled: customFormDisabled, errorMessage: customFormError })),
        react_1.default.createElement(MultiAccepterForm_1.MultiAccepterForm, { accepters: deserialisedData.accepters, onChange: function (accepters) {
                return onChange(__assign(__assign({}, action), { config: (0, SyncAccepterResponses_1.serialiseAccepterResponses)(__assign(__assign({}, deserialisedData), { accepters: accepters })) }));
            }, integrationData: integration })));
};
var getErrorMessage = function (field, config, name) {
    var value = getDropdownSelectedValue(config, field.name);
    return value !== undefined && !field.options.find(function (option) { return option.id === value; })
        ? "No longer exists in ".concat(name)
        : undefined;
};
var getDropdownSelectedValue = function (config, key) {
    var value = config[key];
    return (0, lodash_1.isString)(value) ? value : undefined;
};
var buildActionConfigFromDropdownValue = function (key, value) {
    var _a;
    return value === undefined ? {} : (_a = {}, _a[key] = value, _a);
};
function Dropdown(_a) {
    var label = _a.label, options = _a.options, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, disabledMessage = _a.disabledMessage, errorMessage = _a.errorMessage;
    var MaybeWithTooltip = function (_a) {
        var show = _a.show, children = _a.children, _b = _a.tooltipMessage, tooltipMessage = _b === void 0 ? "" : _b;
        if (show) {
            return (react_1.default.createElement(kaleidoscope_1.Tooltip, { wrapTarget: true, content: tooltipMessage, size: kaleidoscope_1.TooltipSize.Large }, children));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    };
    return (react_1.default.createElement("div", { className: styles.formComponent },
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.formLabel }, (0, lodash_1.capitalize)(label)),
        react_1.default.createElement(MaybeWithTooltip, { show: disabledMessage !== undefined, tooltipMessage: disabledMessage },
            react_1.default.createElement(kaleidoscope_1.Select, { disabled: disabled, label: "Select a field", placeholder: "Select ".concat(label), value: value !== null && value !== void 0 ? value : "", labelHidden: true, autoStack: true, onChange: lodash_1.noop, error: errorMessage }, options.map(function (option, key) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: key, value: option.id, onClick: function () { return onChange(option); } }, option.label)); })))));
}
